export const sendMetriс = (type, value) => {
    window.ym(94564246, type, value)
}
export const getUTMHistoryString = () => {
    const utmHistory = JSON.parse(localStorage.getItem('utm_history')) || [];
    return utmHistory
        .map((utmObj) => {
            return Object.entries(utmObj)
                .map(([key, value]) => {
                    if (key === 'date') {
                        // Convert ISO date string to a UTC format
                        const formattedDate = new Date(value).toLocaleString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: '2-digit',
                            hour12: false,
                            timeZone: 'UTC',
                        });
                        return `${key}: ${formattedDate} UTC`;
                    }
                    return `${key}: ${value}`;
                })
                .join(', ');
        })
        .join('\n');
};
